import { render, staticRenderFns } from "./ShippingAddFormDynamicPrice.vue?vue&type=template&id=24954b99&scoped=true"
import script from "./ShippingAddFormDynamicPrice.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormDynamicPrice.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddFormDynamicPrice.vue?vue&type=style&index=0&id=24954b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24954b99",
  null
  
)

export default component.exports